module.exports = __webpack_public_path__ + "img/aglobalp.168372f7.png";